@if (open) {
  <div
    animate.enter="dialog-enter-animation"
    animate.leave="dialog-leave-animation"
    class="dialog mat-elevation-z4"
    (keyup.escape)="toggleFullscreen(false)"
    [style.width]="actualWidth + 'px'"
    [style.--dialog-slide-distance]="getSlideDistance()"
    [class.dialog--hidden]="hidden"
    [class.dialog--fullscreen]="fullscreen"
    [class.dialog--collapsed]="collapsed">
    <div class="dialog-header">
      <h1>{{dialogTitle || ''}}</h1>
      <ng-content select=".header-buttons"></ng-content>
      @if (allowFullscreen) {
        <button mat-icon-button class="toggle-button" (click)="toggleFullscreen()">
          @if (!fullscreen) {
            <mat-icon svgIcon="fullscreen"></mat-icon>
          }
          @if (fullscreen) {
            <mat-icon svgIcon="fullscreen_exit"></mat-icon>
          }
        </button>
      }
      @if (allowCollapse) {
        <button mat-icon-button class="toggle-button" [tmTooltip]="getExpandCollapseTooltip()" (click)="expandCollapse()">
          @if (!collapsed) {
            <mat-icon svgIcon="chevron_top"></mat-icon>
          }
          @if (collapsed) {
            <mat-icon svgIcon="chevron_bottom"></mat-icon>
          }
        </button>
      }
      <button mat-icon-button class="close-button" (click)="close()" [tmTooltip]="getClosePanelLabel()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
    <div class="dialog-content">
      <ng-content></ng-content>
    </div>
    @if (allowResize && !fullscreen) {
      <div
        (keydown)="onResizeHandleKeyDown($event)"
        (pointerdown)="startResize($event)"
        [attr.aria-label]="getResizeHandleLabel()"
        [attr.aria-orientation]="openFromRight ? 'horizontal' : 'horizontal'"
        [attr.aria-valuemax]="getMaxAllowedWidth()"
        [attr.aria-valuemin]="minWidth"
        [attr.aria-valuenow]="width"
        [class.dialog-resize-handle--left]="openFromRight"
        class="dialog-resize-handle"
        role="slider"
        tabindex="0">
      </div>
    }
  </div>
}
